export const REQUEST_SEGMENTS_MODULE_META_DATA = "REQUEST_SEGMENTS_MODULE_META_DATA";
export const RECEIVE_SEGMENTS_MODULE_META_DATA = "RECEIVE_SEGMENTS_MODULE_META_DATA";
export const TOGGLE_CREATE_UPDATE_SEGMENT_GROUP_MODAL = "TOGGLE_CREATE_UPDATE_SEGMENT_GROUP_MODAL";
export const TOGGLE_DELETE_SEGMENT_GROUP_MODAL = "TOGGLE_DELETE_SEGMENT_GROUP_MODAL";
export const DELETE_SEGMENT_GROUP_SUCCESS = "DELETE_SEGMENT_GROUP_SUCCESS";
export const GROUP_CREATED_UPDATED = "GROUP_CREATED_UPDATED";
export const GROUP_DELETED = "GROUP_DELETED";
export const CUSTOM_SEGMENT_CREATED_UPDATED = "CUSTOM_SEGMENT_CREATED_UPDATED";
export const SHOW_NO_ACCESS_MODAL = "SHOW_NO_ACCESS_MODAL";
export const SET_ENABLED_WIDGETS = "SET_ENABLED_WIDGETS";
export const RECEIVE_SEGMENTS_DASHBOARD_MODULE_META_DATA = "RECEIVE_SEGMENTS_DASHBOARD_MODULE_META_DATA";
export const UPDATE_UNIQUE_SEGMENTS_IDS = "UPDATE_UNIQUE_SEGMENTS_IDS";
